import { jsx as _jsx } from "react/jsx-runtime";
import { lazy, Suspense } from 'react';
// Code-splits the CodePanel + CodeEditor + Monaco out of the main bundle.
// They only load when the user opens a code modal.
const CodePanel = lazy(() => import('./CodePanel'));
export default function CodePanelLazy(props) {
    return (_jsx(Suspense, { fallback: _jsx("div", { className: "modal-backdrop", children: _jsx("div", { className: "modal small-modal", children: _jsx("div", { className: "modal-body padded", children: _jsx("div", { className: "muted", children: "Loading editor\u2026" }) }) }) }), children: _jsx(CodePanel, { ...props }) }));
}
